import React, { useMemo } from 'react'
import styles from '../../styles/modules/Dashboard.module.css'
import DoughnutChart from '../Charts/DoughnutChart'

const DashboardDataCard = ({Icon,data,label}) => {
    function parseValue(val) {
        if (val == null) return 0; // handle null/undefined
        if (typeof val === "number") return val;
        if (typeof val === "string") {
            return Number(val.replace(/,/g, "")); // remove commas and convert
        }
        return Number(val) || 0;
    }
    let newData=[];
    const percentage = useMemo(() => {
        if (!data || data.length < 2) return 0.00;

        const lastMonth = parseValue(data[0]);
        const currentMonth = parseValue(data[1]);
        newData = [lastMonth,currentMonth];
        return calculatePercentageIncrease(lastMonth, currentMonth);
    }, [data]);

    function calculatePercentageIncrease(previous, current) {
        if (isNaN(previous) || isNaN(current)) return 0.00;

        if (previous === 0) {
            if (current === 0) return 0.00;
            return 100.00; // treat as "full increase"
        }

        const increase = ((current - previous) / previous) * 100;
        return Number(increase.toFixed(2));
    }


    return (
        <div className={styles['dashboard_card_con']}>
            <div className={styles['dashboard_card_part_1']}>
                <Icon className={styles['dashboard_card_icon']} />
                <h1>{data?.length == 0 ? 0 : data[1]}</h1>
                <h3>{label}</h3>
            </div>
            <div className={styles['dashboard_card_part_2']}>
                <DoughnutChart labels={['Last Month', 'Current Month']} chartData={newData} height='60px' width='60px' />
               <p>+{percentage}%</p>
            </div>
        </div>
    )
}

export default DashboardDataCard